export class ProgressLoaderState {
  show: boolean;
}
